// extracted by mini-css-extract-plugin
module.exports = {"root":"TransportActionBtns_root__2anhA","btnEdit":"TransportActionBtns_btnEdit__3UcXF"};